import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { H2 } from "../../../../components/basics";
import { Accordion, AccordionSection } from "../../../../components/interactives";
import { termsConditionsValidations } from "../../../../helpers/professional_indemnity/validations";
import useForm from "../../../../hooks/useForm";
import classNamePresets from "../../../../utils/classNamePresets";
import DeclarationTerms from "./terms/DeclarationTerms";
import IndemnityFormStepNavigation from "../../Form/IndemnityFormStepNavigation";
import ImportantNoticesTerms from "./terms/ImportantNoticesTerms";
import ConditionOfRenewal from "./terms/ConditionOfRenewal";
import { RenewalFormContext } from "../Renewal";
import TermsConditions from "../../components/Terms";

type Props = {
  onNext: VoidFunction | null;
  onPrevious: VoidFunction | null;
};
const TermsAndConditions: FC<Props> = ({ onNext, onPrevious }) => {
  const { t } = useTranslation("pages", { keyPrefix: "professionalIndemnity.renewal" });
  const { state, onChange, isSubmitting } = useContext(RenewalFormContext);
  const form = useForm(state, termsConditionsValidations, onChange);
  const {
    field: { accepted, promotionalServices },
  } = form;
  const policyWordingUrl = "/documents/ManulifeProfessionalIndemnityPolicyWordings.pdf";
  const handleNext = () => {
    onNext && form.validateForm(onNext);
  };

  return (
    <>
      <div className="container-flow flex-1">
        <H2 className={classNamePresets.mainHeading}>{t("steps.termsandconditions")}</H2>
        <p className="mt-8">{t("terms.reviewInformation")}</p>
        <Accordion id="terms-info" omitMarginTop>
          <AccordionSection id="important-notices" label={t("terms.importantNotices")}>
            <ImportantNoticesTerms />
          </AccordionSection>
          <AccordionSection id="declaration" label={t("terms.declaration")}>
            <DeclarationTerms />
          </AccordionSection>
          <AccordionSection initialState="expanded" id="condtionofrenewal" label={t("terms.conditionsofrenewal")}>
            <ConditionOfRenewal />
          </AccordionSection>
          <TermsConditions
            policyWordingUrl={policyWordingUrl}
            isAccordionExpanded={false}
            state={state}
            t={t}
            promotionalServices={promotionalServices}
            accepted={accepted}
          />
        </Accordion>
      </div>
      <IndemnityFormStepNavigation isLoading={isSubmitting} onBack={onPrevious} onSubmit={handleNext} />
    </>
  );
};

export default TermsAndConditions;
